import { Fragment, useEffect, useState } from 'react';
import { Button, Divider, message, Modal } from 'antd';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import { useTranslation } from 'react-i18next';
import useStore from '../../store/useStore';
import { useMutationDeletePermission } from '../../hooks/useMutationData';
import './Modals.scss';

const ModalDeletePermission = () => {
  const { t } = useTranslation();
  const { ui, setUi } = useStore();
  const { showModalDeletePermission, permissionSelected } = ui;
  const [errorAlert, setErrorAlert] = useState('');
  const { mutate, isSuccess, isLoading, isError, error } = useMutationDeletePermission();

  const deletePermission = () => {
    mutate(permissionSelected?.name);
  };

  const onCloseModal = () => {
    setUi({ showModalDeletePermission: false });
  };

  useEffect(() => {
    if (isSuccess) {
      onCloseModal();
    } else if (isError) {
      const errorResponse = error.response?.data;
      if (errorResponse?.error === 'ROLE_ASSOCIATED') {
        setErrorAlert(t('modals.delete.permissionLinkedError'));
      }
    }
  }, [isLoading]);

  return (
    <Modal
      title={`${t('modals.delete.title')}`}
      centered
      className="turbo-permissions-mf__modal--no-width"
      visible={showModalDeletePermission}
      closeIcon={<CloseCircleOutlined onClick={onCloseModal} />}
      onCancel={onCloseModal}
      footer={[
        <Button
          className="turbo-permissions-mf__modal-footer-button"
          key="submit"
          type="primary"
          onClick={deletePermission}
          loading={isLoading}
        >
          <>{t('modals.delete.button')}</>
        </Button>
      ]}
    >
      <h2 className="turbo-permissions-mf__modal-subtitle-light">
        {`${t('modals.delete.deletePermission')}> ${permissionSelected?.name}?`}
      </h2>
      {errorAlert && (
        <>
          <Divider></Divider>
          <p className="turbo-permissions-mf__alert--error">{`${errorAlert}`}</p>
        </>
      )}
    </Modal>
  );
};

export default ModalDeletePermission;
